class OurTeam extends HTMLElement {
    constructor() {
      // Always call super first in constructor
      super();
      this.currentIndex = 0;
      this.cardWrapper = this.querySelector('.team-card-wrapper');
      this.cardItems = this.querySelectorAll('.team-card-item');
      this.popupWrapper=this.querySelector('.team-popup-wrapper');
      this.sliderItems = this.querySelectorAll('.team-slide-item');
      this.totalSlides=this.sliderItems.length || 0;
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.closeButton = this.querySelector('button[name="close"]');
      
      if (!this.totalSlides || !this.cardWrapper) return;

      this.initSection();
      const resizeObserver = new ResizeObserver(entries => this.initSection());
      resizeObserver.observe(this.cardWrapper);

      this.cardItems.forEach((ci)=>{
        ci.addEventListener('click', this.onCardClick.bind(this));
      });
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      this.closeButton.addEventListener('click', this.hidePopup.bind(this));
    }

    initSection(){
      this.updateSlider();
    }

    showPopup(){
     document.body.classList.add('disable-scroll');
     this.popupWrapper.classList.add('show');
    }
    
    hidePopup(){
      document.body.classList.remove('disable-scroll');
      this.popupWrapper.classList.remove('show');
    }
    
    onCardClick(event) {
      this.currentIndex= parseInt(event.currentTarget.dataset.index) || 0;
      this.showPopup(); 
      this.updateSlider();
    }
    
    onButtonClick(event) {
      if(event.currentTarget.name == 'next'){
        this.currentIndex= (this.currentIndex == this.totalSlides - 1)? 0 : this.currentIndex + 1;
      }else if(event.currentTarget.name == 'previous'){
        this.currentIndex= (this.currentIndex == 0) ? this.totalSlides - 1 : this.currentIndex - 1; 
      }
      this.updateSlider();
    }

    updateSlider(){
      if(this.totalSlides == 0) return;
      this.sliderItems.forEach((si)=>{
        si.classList.remove('active');
      })
      this.sliderItems[this.currentIndex].classList.add('active');
    }
  }
  
  customElements.define("our-team", OurTeam);